import { Component, OnInit } from '@angular/core';
import { Department, ResponseDataBase, Subdepartment } from '../../../../interfaces/index.interface';
import { ResourceService, UserService } from '../../../../services/index.service';
import { DatabaseResourcesService } from '@services/database-resources/database-resources.service';
import { AppConstants } from '@app/appConstants';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalComponent } from '@components/modals/confirmation-modal/confirmation-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { Hospital } from '../../../../interfaces/hospital.interface';
import { Consultant } from '../../../../interfaces/consultant.interface';
import { environment } from '../../../../../environments/environment';

declare var $: any;

@Component({
  selector: 'database-resources-consultants',
  templateUrl: './consultants.page.html',
  styleUrls: ['./consultants.page.scss']
})
export class ConsultantsPage implements OnInit {

  hospitals: Array<Hospital>;
  hospital: Hospital;
  department: Department;
  departments: Array<Department>;
  subdepartment: Subdepartment;
  subdepartments: Array<Subdepartment>;
  consultants: Array<Consultant>;
  searchedConsultants: Array<Consultant>;
  alert;
  action;
  consultant: Consultant = {
    id: '',
    email: '',
    name: '',
    phoneNumber: '',
    address: '',
    flatNumber: ''
  };
  newConsultant: any = {
    id: '',
    name: '',
    email: '',
    phoneNumber: '',
    address: '',
    flatNumber: '',
    password: '',
    language: environment.DEFAULTLANGUAGE,
    portalRole: 'consultant'
  };
  constructor(public _userService: UserService, public _resourceService: ResourceService, public modalService: NgbModal,
    public _databaseResourcesService: DatabaseResourcesService, public translate: TranslateService) {
    if (!_databaseResourcesService.haveAllResources()) {
      this._databaseResourcesService.getAllResources();
    }
    if (_userService.user.role == 'assistant') {
      this.searchConsultantsByAssistant();
    }
  }

  getAllHospitals() {
    this._resourceService.getResource('allhospitals')
      .subscribe(data => {
        let response = data as ResponseDataBase;
        this.hospital = response.result[0];
        this.hospitals = response.result;
        this._databaseResourcesService.loading = false;
      });
  }

  getDepartments(hospital) {
    let params = {
      hospitalId: hospital.id,
    };
    this._databaseResourcesService.getDepartments(params)
      .subscribe(data => {
        let response = data as ResponseDataBase;
        this.departments = response.result;
        this._databaseResourcesService.loading = false;
      });
  }

  getSubdepartments(department) {
    let params = {
      departmentId: department.id,
    };
    this._databaseResourcesService.getSubdepartments(params)
      .subscribe(data => {
        let response = data as ResponseDataBase;
        this.subdepartments = response.result;
        this._databaseResourcesService.loading = false;
      });
  }

  searchConsultants() {
    let params = {
      id: this.consultant.id,
      name: this.consultant.name,
    };
    this._databaseResourcesService.searchConsultants(params)
      .subscribe(data => {
        let response = data as ResponseDataBase;
        this.searchedConsultants = response.result;
        this._databaseResourcesService.loading = false;
      });
  }

  searchConsultantsByAssistant() {
    let params = {
      id: this.consultant.id,
      assistantId: this._userService.user.email,
    };
    this._databaseResourcesService.searchConsultants(params)
      .subscribe(data => {
        let response = data as ResponseDataBase;
        this.searchedConsultants = response.result;
        this._databaseResourcesService.loading = false;
      });
  }

  madeUnitToGetConsultants() {
    let unit = {
      id: this.department.id,
      type: 'department',
    };
    if (this.subdepartment) {
      unit.id = this.subdepartment.id;
      unit.type = 'subdepartment';
    }
    this.getConsultantsFromUnit(unit);
  }

  getConsultantsFromUnit(unit) {
    let params = {
      id: unit.id,
      type: unit.type,
    };
    this._databaseResourcesService.getConsultantsFromUnit(params)
      .subscribe(data => {
        let response = data as ResponseDataBase;
        this.searchedConsultants = response.result;
        this._databaseResourcesService.loading = false;
      });
  }

  addConsultant(consultant) {
    this._userService.loading = true;
    delete this.searchedConsultants;
    if (consultant.name && consultant.id && consultant.lastname && consultant.phoneNumber && consultant.email) {
      delete this._resourceService.alert;
      this._userService.registerAdminUser(consultant).subscribe(data => {
        let response = data as ResponseDataBase;
        if (response.METADATA.STATUS != AppConstants.STATUS.ERROR) {
          let warning;
          if (response.METADATA.STATUS == AppConstants.STATUS.ALERT) {
            warning = response.METADATA.ERROR_MESSAGE;
          }
          $('#consultantModal').modal('hide');
          this.translate.get('CONSULTANT_ADDED').subscribe(
            translation => {
              this._resourceService.alert = translation;
            });
        } else {
          this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
          window.scrollTo(0, 0);
        }
        this._userService.loading = false;
      });

    } else {
      this._resourceService.alert = 'PLEASE_FILL_FIELDS_MARKS_WITH';
    }
  }

  deleteConsultant(consultant) {
    let modal = this.modalService.open(ConfirmationModalComponent, {
      windowClass: 'modal-fade',
      backdrop: 'static',
      keyboard: false,
      size: 'sm'
    });
    modal.componentInstance.header = 'DELETE_CONSULTANT';
    modal.componentInstance.message = 'CONFIRM_DELETE';
    modal.componentInstance.data = { action: "delete", consultant: consultant };
    modal.componentInstance.action.subscribe((response) => {
      this.confirmDeleteConsultant(response.consultant);
    });
  }

  confirmDeleteConsultant(consultant) {
    let params = {
      consultantId: consultant.id,
    };
    this._databaseResourcesService.deleteConsultant(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.translate.get('HAS_BEEN_DELETED').subscribe(
          translation => {
            let name = consultant.name
            this._resourceService.alert = name + " " + translation;
            window.scrollTo(0, 0);
            delete this.searchedConsultants;
          });
        this._databaseResourcesService.getAllResources();
      } else {
        this.alert = response.METADATA.ERROR_MESSAGE;
        this._databaseResourcesService.loading = false;
      }
    });
  }

  editConsultant(consultant) {
    delete this._resourceService.alert;
    this.action = 'update';
    this.consultant = consultant;
  }

  ngOnInit() {
  }

}
